import React, { useMemo } from "react";
import useFetchAiAnalyticsWidgetData from "../../../hooks/useFetchAiAnalyticsWidgetData";
import MultiFeatureCard from "../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard";
import GenericChart from "../GenericChart";
import get from "lodash/get";

const TopPainPointAndCompllimentChart = (props) => {
    const {
        itemData,
        applied_filter_values,
        timeperiodLabel
    } = props;

    const { data, isLoading } = useFetchAiAnalyticsWidgetData({
        widgetId: get(itemData, "widgetId", ""),
        appliedFilterValues: applied_filter_values,
        "widget_config": get(itemData, "widget_config", {}),
        widgetIdPrefixForUniqueStoreMapping: get(itemData, "sortFieldName", "")
    })

    const { categories, seriesData } = useMemo(() => {
        if (!data) return { categories: [], seriesData: [] }
        const columnIndex = get(data, "columns", []).indexOf(get(itemData, "activeFieldName", "Complements"))
        return ({
            categories: get(data, "rows", []),
            seriesData: [
                {
                    name: get(itemData, "title", ""),
                    data: get(data, "metric_data", [])?.map(item => item[columnIndex] || 0),
                }
            ]

        })
    }, [data])
    return (
        <MultiFeatureCard
            title={get(itemData, 'title', '')}
            subTitle={timeperiodLabel}
            loading={isLoading}
            isNoData={!isLoading && !categories.length}
            renderContent={() => {
                return (
                    <GenericChart
                        defaultConfig={get(itemData, "chartDefaultConfig", {}) || {}}
                        xAxisCategories={categories}
                        series={seriesData}
                        tooltipValueKeysConfig={{
                            isheaderVisible: false,
                            headerLabelKey: "",
                            bodyLabelKey: "category",
                            bodyValueKey: "y"
                        }
                        }
                    />
                )
            }}
        />
    )
}

export default TopPainPointAndCompllimentChart